<mat-toolbar color="primary">
  <span id="spørreundersøkelse-generer-analyse-debug-dialog-tittel">Generer analyse (debug)</span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="lukk()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (laster()) {
  <mat-progress-bar mode="indeterminate"/>
}

<form [formGroup]="skjema" (ngSubmit)="genererAnalyse()" data-testid="spørreundersøkelse-generer-analyse-debug-skjema" novalidate>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Prompt</mat-label>
      <textarea matInput [formControl]="skjema.controls.prompt" rows="20" data-testid="prompt-felt"></textarea>
    </mat-form-field>

    @if (resultat(); as resultat) {
      <div class="resultat" data-testid="resultat">
        <html-formatert [innhold]="resultat.analyseSomHtml"/>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="lukk()">Lukk</button>
    <submit-button [skjema]="skjema" [arbeidPaagaar]="genererer()" spinnerTekst="Genererer...">
      Generer analyse
    </submit-button>
  </mat-dialog-actions>
</form>
